import { Box, Stack } from "@mui/material";
import { PrimaryFormDateOfBirth } from "react-common-ui-library";
import { Email } from "react-common-ui-library/FPACT/Email";
import {
  StyledFormInputsBox,
  StyledSmallerFieldWrapperBox,
} from "../../../Styles/Common/CommonStyles";
import ForgotUsernameInfoAlert from "./ForgotUsernameInfoAlert";
import {
  FORGOT_USERNAME_CONTENT_2,
  GET_USERNAME,
} from "../../../Constants/ForgotUsernameConstants";
import { GetUsernameButtonWrapper } from "../../../Styles/Login/ForgotUsername/ForgotUsernameStyles";
import { StyledButton } from "react-common-ui-library/FPACT/Buttons";
import { CONTAINED, SUBMIT } from "../../../Constants/CommonConstants";
import { useIntl } from "react-intl";

/**
 * @description Forgot username form elements that can be imported in ForgotUsername component.
 * @returns {ReactNode} Render the Email and Date of birth inputs with submit button.
 */
const ForgotUsernameFormElements = () => {
  const intl = useIntl();

  return (
    <Stack spacing={7}>
      <Stack spacing={4}>
        <StyledFormInputsBox>
          <Email />
        </StyledFormInputsBox>
        <StyledSmallerFieldWrapperBox>
          <PrimaryFormDateOfBirth />
        </StyledSmallerFieldWrapperBox>
      </Stack>
      <Stack spacing={{ xs: 11, md: 10 }}>
        <ForgotUsernameInfoAlert contentId={FORGOT_USERNAME_CONTENT_2} />
        <GetUsernameButtonWrapper>
          <Box>
            <StyledButton
              variant={CONTAINED}
              fullWidth
              id={GET_USERNAME}
              type={SUBMIT}
            >
              {intl.formatMessage({
                id: GET_USERNAME,
              })}
            </StyledButton>
          </Box>
        </GetUsernameButtonWrapper>
      </Stack>
    </Stack>
  );
};

export default ForgotUsernameFormElements;
